/**
 * Accordion — toggle [data-hn-accordion] sections via aria-expanded + [hidden] panel.
 */
export function initAccordions() {
    document.querySelectorAll('[data-hn-accordion]').forEach((root) => {
        root.addEventListener('click', (e) => {
            const trigger = e.target.closest('.hn-accordion__trigger');
            if (!trigger || !root.contains(trigger)) return;

            const item = trigger.closest('.hn-accordion__item');
            const panelId = trigger.getAttribute('aria-controls');
            const panel = panelId ? document.getElementById(panelId) : null;
            if (!item || !panel) return;

            const open = trigger.getAttribute('aria-expanded') === 'true';
            trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
            item.classList.toggle('is-open', !open);
            if (open) {
                panel.setAttribute('hidden', '');
            } else {
                panel.removeAttribute('hidden');
            }
        });
    });
}
